/** Semi-circle concern score gauge — matches SkinRoutinePage drawing. */
export function drawConcernGauge(canvas, score) {
  if (!canvas || score == null) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const numeric = Math.max(0, Math.min(100, Number(score) || 0));
  const cx = 200;
  const cy = 200;
  const outerRadius = 150;
  const innerRadius = 115;
  const totalSegments = 20;
  const gap = 0.04;

  const getSegmentColor = (segmentValue) => {
    if (segmentValue >= 0 && segmentValue <= 39) return '#ff4757';
    if (segmentValue >= 40 && segmentValue <= 59) return '#ffa502';
    if (segmentValue >= 60 && segmentValue <= 74) return '#eccc68';
    if (segmentValue >= 75 && segmentValue <= 89) return '#7bed9f';
    return '#2ed573';
  };

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  for (let i = 0; i < totalSegments; i += 1) {
    const segmentValue = (i / totalSegments) * 100;
    const startAngle = Math.PI + (i * (Math.PI / totalSegments)) + gap;
    const endAngle = Math.PI + ((i + 1) * (Math.PI / totalSegments)) - gap;

    ctx.beginPath();
    ctx.arc(cx, cy, outerRadius, startAngle, endAngle);
    ctx.arc(cx, cy, innerRadius, endAngle, startAngle, true);
    ctx.closePath();
    ctx.fillStyle = segmentValue <= numeric ? getSegmentColor(segmentValue) : '#f1f2f6';
    ctx.fill();
  }

  const needleAngle = Math.PI + (numeric / 100) * Math.PI;

  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate(needleAngle);

  ctx.beginPath();
  ctx.moveTo(0, -4);
  ctx.lineTo(innerRadius - 10, 0);
  ctx.lineTo(0, 4);
  ctx.fillStyle = '#2d3436';
  ctx.fill();

  ctx.beginPath();
  ctx.arc(0, 0, 12, 0, Math.PI * 2);
  ctx.fillStyle = '#fff';
  ctx.fill();
  ctx.strokeStyle = '#2d3436';
  ctx.lineWidth = 3;
  ctx.stroke();

  ctx.restore();
}
